import React from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import PageTitle from "../components/pagetitle";
import CrowdfundingDescription from "../components/Crowdfunding";
import Footer from "../components/footer/footer";
import Scrollbar from "../components/scrollbar";
import data from "../assets/data.json";

const CrowdfundingPage = () => {
  const location = useLocation();

  const baseURL = location.pathname.split("/")[1];

  const pageData = data[baseURL];
  return (
    <>
      <Navbar />
      <PageTitle backgroundClassName={"crowdfounding-page"} title={pageData.title} />
      <CrowdfundingDescription
        description={pageData.description}
      />
      <Footer />
      <Scrollbar />
    </>
  );
};
export default CrowdfundingPage;
